/**
 * policy-accordion.js
 * Vault Beauty — Policy Page Accordion
 *
 * Shopify's Policy editor strips <details>/<summary>/<style> from pasted
 * content, so the accordion structure can't survive being saved directly
 * in a policy's body. Instead, this script finds the plain h3 headings
 * that DO survive (headings are basic semantic HTML, always allowed) and
 * builds the accordion around them at page-load time.
 *
 * The policy body actually renders nested as:
 *   .shopify-policy__container > .shopify-policy__body > .rte > (your content)
 * so this targets .rte specifically, not the outer container.
 *
 * Expected structure in the policy body (as pasted into Shopify admin):
 *   <h2>Part label</h2>          -- optional, non-collapsible section divider
 *   <h3>1. Clause Title</h3>     -- becomes the accordion trigger
 *   <p>...</p> / <ol>...</ol>    -- becomes the accordion's collapsible content
 *   <h4>1.1 Sub-heading</h4>     -- stays inline inside the accordion, not its own trigger
 *   <h3>2. Next Clause</h3>      -- starts a new accordion; the previous one's content
 *                                    is everything between the two h3s (or up to the
 *                                    next h2, or the end of the container)
 */
(function () {
  'use strict';

  function buildAccordion(container) {
    // Snapshot the original top-level children once, before any mutation,
    // so we can walk a stable array instead of the live (mutating) DOM.
    var original = Array.prototype.slice.call(container.children);
    var consumed = new Set();

    original.forEach(function (node, idx) {
      if (consumed.has(node)) return; // already moved into an earlier accordion
      if (node.tagName !== 'H3') return; // only h3 starts a new accordion group

      var details = document.createElement('details');
      var summary = document.createElement('summary');
      summary.textContent = node.textContent;
      var content = document.createElement('div');

      for (var j = idx + 1; j < original.length; j++) {
        var sibling = original[j];
        if (sibling.tagName === 'H2' || sibling.tagName === 'H3') break;
        content.appendChild(sibling); // moves it out of the container into content
        consumed.add(sibling);
      }

      details.appendChild(summary);
      details.appendChild(content);
      node.parentNode.replaceChild(details, node);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('.shopify-policy__container .rte');
    if (!container) return;
    buildAccordion(container);
  });
})();